'use strict';

import {Helper} from "../helpers/Helper.js";

export default class FilterableCardsList {
	#block;
	#listWrapper;
	#itemsList;
	#items;
	#sortTypeSelect;
	#searchField;
	#otherFilters;
	#jumpInput;

	#action;

	#pagination;
	#itemsPerPage;
	#pagesCount;
	#pagesCountInitial;
	#pagingCurrentPage;
	#adminAjax;

	#isEditor;

	constructor(listWrapper, isEditor = false) {
		this.#itemsList = [];
		this.#listWrapper = listWrapper;
		this.#block = listWrapper.parentElement;
		this.#sortTypeSelect = this.#block.querySelector('select.list_filter');
		this.#searchField = this.#block.querySelector('input.list_search');
		this.#otherFilters = Array.from(this.#block.querySelectorAll('.list_custom_filter'));
		this.#items = this.#listWrapper.querySelectorAll('.list-item');
		this.#jumpInput = this.#block.querySelector('.pagination-jump-input');

		this.#pagination = this.#listWrapper?.dataset?.pagination === 'true';
		this.#itemsPerPage = +this.#listWrapper?.dataset?.perPage;
		this.#itemsPerPage = this.#itemsPerPage === 0 ? this.#itemsList.length : this.#itemsPerPage || 9;
		this.#pagesCount = 1;
		this.#action = this.#listWrapper.dataset.action

		this.#adminAjax = this.#listWrapper?.dataset?.adminAjax
			|| window?.admin_ajax?.[0]
			|| window?.ajaxurl
			|| window?.wc_add_to_cart_params?.ajax_url
			|| (window?.location ? `${window.location.origin}/wp-admin/admin-ajax.php` : '');

		this.#isEditor = isEditor;

		this.#pagingCurrentPage = 1;
	}

	initialize() {
		this.#addEvents();
		this.update(false);
	}

	#syncPagingState() {
		this.#pagination = this.#listWrapper?.dataset?.pagination === 'true';
		this.#itemsPerPage = +(this.#listWrapper?.dataset?.perPage || 9);

		const pagesCountAttr = this.#block.querySelector('.levcharity-pagination')?.dataset?.pagesCount;
		this.#pagesCount = pagesCountAttr !== undefined && pagesCountAttr !== ''
			? Number(pagesCountAttr)
			: 1;

		if (Number.isNaN(this.#pagesCount) || this.#pagesCount < 1) {
			this.#pagesCount = 1;
		}

		if (this.#pagingCurrentPage > this.#pagesCount) {
			this.#pagingCurrentPage = 1;
		}
	}

	update(request = true) {
		const applyUpdate = () => {
			this.#syncPagingState();

			if (request) {
				if (!this.#adminAjax) {
					console.warn('LevCharity pagination: admin-ajax endpoint is missing.');
					return;
				}

				document.body.classList.add('ajax-loading')
				if(!this.#pagesCountInitial) {
					this.#pagesCountInitial = this.#pagesCount;
				}
				const extra_filters = {};
				this.#otherFilters.forEach(field => {
					extra_filters[field.name] = field.value;
				})
				Helper.request(this.#adminAjax, {
					action: 'levcharity_filterable_card_list_' + this.#action,
					current_page: this.#pagingCurrentPage,
					search: this.#searchField?.value || '',
					extra_filters,
					per_page: this.#itemsPerPage,
					sort: this.#sortTypeSelect?.value || '',
					id: this.#listWrapper?.dataset?.campaign || '',
					data: JSON.parse(this.#listWrapper?.dataset?.data || '{}')
				}).then((response) => {
					if(response.page) {
						this.#pagingCurrentPage = response.page;
						this.#pagesCount = Math.ceil(response.total / this.#itemsPerPage);
					} else {
						this.#pagingCurrentPage = 1;
						this.#pagesCount = Math.ceil(response.total / this.#itemsPerPage);
					}
					this.#listWrapper.innerHTML = response.html;

					if ( ! this.#pagesCount && ! this.#listWrapper.innerHTML ) {
						this.#listWrapper.innerHTML = 'Nothing found.';
					}
				}).finally(() => {
					this.updatePaging();
					document.body.classList.remove('ajax-loading')
				});
			} else {
				this.updatePaging();
			}
		};

		if (request) {
			setTimeout(applyUpdate, 100);
		} else {
			applyUpdate();
		}
	}

	#addEvents() {
		this.#block.addEventListener('change', (event) => {
			if (event.target === this.#sortTypeSelect || this.#otherFilters.includes(event.target)) {
				this.#pagingCurrentPage = 1;
				this.update();
			}
		});

		let searchTimeout = null;

		this.#block.addEventListener('input', (event) => {
			if (event.target === this.#searchField) {
				clearTimeout(searchTimeout);

				searchTimeout = setTimeout(() => {
					this.#pagingCurrentPage = 1;
					this.update();
				}, 600)

			}
		})

		let paginationTimeout = 0;

		this.#block.addEventListener('click', (event) => {
			if (event.target.matches('.pagination-button') || event.target.closest('.pagination-button')) {
				event.preventDefault()
				const button = event.target.matches('.pagination-button') ? event.target : event.target.closest('.pagination-button');

				if (button.classList.contains('next')) {
					if (this.#pagingCurrentPage >= this.#pagesCount) return;
					this.#pagingCurrentPage++;
				} else if (button.classList.contains('prev')) {
					if (this.#pagingCurrentPage <= 1) return;
					this.#pagingCurrentPage--;
				} else {
					const targetPage = +button?.dataset?.page || 1;
					if (targetPage < 1 || targetPage > this.#pagesCount) return;
					this.#pagingCurrentPage = targetPage;
				}
				this.updatePaging()
				clearTimeout(paginationTimeout);

				paginationTimeout = setTimeout(() => {
					this.update();
				}, 600)
			}
		});

		if (this.#jumpInput) {
			const handleJump = () => {
				const rawValue = Number(this.#jumpInput.value);
				if (Number.isNaN(rawValue)) return;
				const targetPage = Math.min(Math.max(rawValue, 1), this.#pagesCount);
				if (targetPage === this.#pagingCurrentPage) return;
				this.#pagingCurrentPage = targetPage;
				this.updatePaging();
				clearTimeout(paginationTimeout);
				paginationTimeout = setTimeout(() => {
					this.update();
				}, 600);
			};

			this.#jumpInput.addEventListener('keydown', (event) => {
				if (event.key !== 'Enter') return;
				event.preventDefault();
				handleJump();
			});

			this.#jumpInput.addEventListener('blur', handleJump);
		}
	}

	generateCampaignsArray() {

	}

	updatePaging() {

		const paginationWrapper = this.#block.querySelector('.levcharity-pagination');

		if (!paginationWrapper) return;
		if (this.#pagesCount <= 1) {
			paginationWrapper.style.display = 'none'
		} else {
			paginationWrapper.style.display = '';
		}

		const buttonNext = paginationWrapper.querySelector('.pagination-button.next');
		const buttonPrev = paginationWrapper.querySelector('.pagination-button.prev');

		buttonNext.classList.remove('disabled')
		buttonNext.removeAttribute('disabled')

		buttonPrev.classList.remove('disabled')
		buttonPrev.removeAttribute('disabled')

		if (this.#pagingCurrentPage === 1){
			buttonPrev.classList.add('disabled')
			buttonPrev.setAttribute('disabled', true)
		} else if (this.#pagingCurrentPage === this.#pagesCount) {
			buttonNext.classList.add('disabled')
			buttonNext.setAttribute('disabled', true)
		}

		const placeholderLeft = paginationWrapper.querySelector('.pagination-button.placeholder-1');
		const placeholderRight = paginationWrapper.querySelector('.pagination-button.placeholder-2');

		const pageButtons = Array.from(
			paginationWrapper.querySelectorAll('.pagination-button:not(.prev):not(.next):not(.placeholder)')
		);

		const totalPages = Number(this.#pagesCount) || pageButtons.length || 1;
		const currentPage = Number(this.#pagingCurrentPage) || 1;
		const showAll = totalPages <= 7;
		let rangeStart = 1;
		let rangeEnd = totalPages;
		let showLeftEllipsis = false;
		let showRightEllipsis = false;

		if (!showAll) {
			if (currentPage <= 4) {
				rangeStart = 1;
				rangeEnd = 5;
				showRightEllipsis = true;
			} else if (currentPage >= totalPages - 3) {
				rangeStart = totalPages - 4;
				rangeEnd = totalPages;
				showLeftEllipsis = true;
			} else {
				rangeStart = currentPage - 2;
				rangeEnd = currentPage + 2;
				showLeftEllipsis = true;
				showRightEllipsis = true;
			}
		}

		pageButtons.forEach((button, index) => {
			const pageNumber = index + 1;
			const isVisible = showAll
				|| pageNumber === 1
				|| pageNumber === totalPages
				|| (pageNumber >= rangeStart && pageNumber <= rangeEnd);

			if (pageNumber === currentPage) {
				button.classList.add('current');
			} else {
				button.classList.remove('current');
			}

			if (!isVisible || totalPages <= index) {
				button.classList.add('hidden');
			} else {
				button.classList.remove('hidden');
			}
		});

		if (placeholderLeft) {
			if (showLeftEllipsis) {
				const startButton = pageButtons[rangeStart - 1];
				if (startButton) {
					startButton.before(placeholderLeft);
				}
				placeholderLeft.classList.remove('hidden');
				placeholderLeft.dataset.page = String(rangeStart - 1);
			} else {
				placeholderLeft.classList.add('hidden');
				delete placeholderLeft.dataset.page;
			}
		}

		if (placeholderRight) {
			if (showRightEllipsis) {
				const lastButton = pageButtons[totalPages - 1];
				if (lastButton) {
					lastButton.before(placeholderRight);
					lastButton.classList.remove('hidden');
				}
				placeholderRight.classList.remove('hidden');
				placeholderRight.dataset.page = String(rangeEnd + 1);
			} else {
				placeholderRight.classList.add('hidden');
				delete placeholderRight.dataset.page;
			}
		}

		if (this.#jumpInput) {
			this.#jumpInput.max = String(this.#pagesCount || 1);
			this.#jumpInput.value = String(this.#pagingCurrentPage || 1);
			this.#jumpInput.disabled = this.#pagesCount <= 1;
		}

		paginationWrapper.classList.add('is-pagination-ready');
	}
}
